import React from "react";
import { displayIdOrOrphan } from "../../../utils/constants/ads";

/** A stage this row has not reached yet. */
export const NoStage = () => <span className="text-gray-400">—</span>;

const FieldLabel = ({ children }) => (
  <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
    {children}
  </span>
);

/** Parent ad and delivery id stacked, so two narrow columns become one. */
export const IdPair = ({ adId, deliveryId }) => (
  <div className="grid grid-cols-[auto_auto] justify-items-start gap-x-2 gap-y-0.5">
    <FieldLabel>Parent Id</FieldLabel>
    <span>{displayIdOrOrphan(adId)}</span>
    <FieldLabel>Delivery Id</FieldLabel>
    <span>{deliveryId ?? "—"}</span>
  </div>
);

const dot = (color) => ({
  display: "inline-block",
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: color,
});

/** Asset upload state with an S3 retry button when migration is missing. */
export const AssetCell = ({ delivery, retryS3 }) => {
  if (!delivery.ad_asset_url) return "—";
  const retrying = retryS3.isPending && retryS3.variables === delivery.id;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      Uploaded
      {delivery.s3_asset_url ? (
        <span title="Migrated to S3" style={dot("#10b981")} />
      ) : (
        <button
          type="button"
          title="Retry S3 migration"
          disabled={retrying}
          onClick={(e) => {
            e.stopPropagation();
            retryS3.mutate(delivery.id);
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <span style={dot("#f59e0b")} />
          <span style={{ fontSize: 10, color: "#f59e0b", fontWeight: 600 }}>
            {retrying ? "…" : "Retry"}
          </span>
        </button>
      )}
    </span>
  );
};
